import api from "./api"; // Asumimos que tu instancia configurada de axios está aquí

/**
 * Planifica una acción y devuelve la respuesta COMPLETA del backend.
 */
export const planAction = async (gameId, unitId, actionSlug, targetData, originData) => {
    // Include origin_data in the API call
    const response = await api.post(`/api/games/${gameId}/planned_actions`, {
        unit_id: unitId,
        action_slug: actionSlug,
        target_data: targetData,
        origin_data: originData, // ✅ NOW SENDING CORRECT ORIGIN POSITION
    });
    
    // --- ¡AQUÍ ESTÁ LA CORRECCIÓN MÁS IMPORTANTE! ---
    // En lugar de devolver una parte de la respuesta, devolvemos la respuesta
    // completa que nos da el interceptor de api.js.
    // Esta respuesta ya es el cuerpo del JSON del backend.
    return response; 
};

/**
 * Cancela una acción y devuelve la respuesta COMPLETA del backend.
 */
export const cancelPlannedActionApi = async (gameId, plannedActionId) => {
    const response = await api.delete(`/api/games/${gameId}/planned_actions/${plannedActionId}`);
    // Aplicamos la misma estandarización aquí para el futuro.
    return response.data;
};

/**
 * Obtiene las acciones planificadas del equipo.
 * Esta función es específica y devuelve solo lo que su nombre indica.
 */
export const getTeamPlannedActions = async (gameId) => {
    const response = await api.get(`/api/games/${gameId}/team_planned_actions`);
    // Como esta no devuelve un GameState, la dejamos como está.
    console.info("[getTeamPlannedActions] response:", response);
    return response.data.team_planned_actions;
};

/**
 * Obtiene las acciones disponibles para una unidad.
 * Esta función es específica y devuelve solo lo que su nombre indica.
 */
export const getAvailableActions = async (gameId, unitId) => {
    const response = await api.get(`/api/games/${gameId}/units/${unitId}/available-actions`);
    // Como esta no devuelve un GameState, la dejamos como está.
    // console.info("[getAvailableActions] response:", response);
    return response.data.available_actions;
};